<template>
  <v-col
    v-if="show"
    cols="12"
    sm="6"
    class="summary"
  >
    <label
      class="summary-label"
      :class="{'error--text': validator.$invalid }"
    >{{ summaryLabel }}</label>
    <span class="summary-text">{{ summaryText }}</span>
  </v-col>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        default: '',
        required: true
      },
      validator: {
        type: Object,
        default: function () {
          return {}
        },
        required: true
      },
      text: {
        type: String,
        default: '',
        required: false
      },
      bool: {
        type: Boolean,
        default: false,
        required: false
      },
      bool12: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    computed: {
      summaryLabel () {
        return this.$t('labels["' + this.label + '"]')
      },
      summaryText () {
        if (this.text !== '') {
          return this.text
        } else if (this.bool) {
          if (typeof this.validator.$model === 'boolean') {
            return this.validator.$model ? this.$t('common.yes') : this.$t('common.no')
          } else {
            return ''
          }
        } else if (this.bool12) {
            return this.validator.$model == 1 ? this.$t('common.yes') : this.$t('common.no')
        } else {
          return this.validator.$model
        }
        // return this.text !== '' ? this.text : this.validator.$model
      },
      show () {
        if (this.summaryText !== '' || this.validator.$invalid) {
          return true
        } else {
          return false
        }
      }
    }
  }
</script>
